<template>
    <div :class="'mobileButtonContainer'+(availableButtons.length!=0?' active':'')" ref="mobileButtonContainer">
        <div :class="'singleButtonContainer '+availableButton.curState" v-for="availableButton in availableButtons" :key="availableButton.buttonType+availableButton.name" @click="itemClicked(availableButton)">
            <div class="singleButtonInnerContainer" :id="availableButton.buttonType+availableButton.name">
                <fa-icon
                :icon="iconsMap[availableButton.buttonType]"
                ></fa-icon>
                <div class="textContainer">{{availableButton.name}}</div>
            </div>
            <div class="singleButtonAnimatingDiv"></div>
        </div>
    </div>
</template>
<script>
import "../scss/mobile-button-container.css";
export default {
  props: {
    overlayContent: {
      type: Object,
      required: true,
    },
  },
  data(){
      return{
        availableButtons:[],
        iconsMap:{
            "resource":['fas', 'external-link-alt'],
            "speaker":['fas', 'user'],
            "isThisForMe":['fas', 'question-circle'],
        },
        lastTouch:{
            initialPosx:0,
            lastPosx:0,
            touchItem:0,
            isSliding:false,

        }
      }
  },
  mounted(){
    let buttons=this.overlayContent.overlays.filter(x=>x.type=="button")
    let buttonTypes=buttons.map(x=>x.instanceData.buttonType)
    let uniqueButtonTypes = buttonTypes.reduce(function(a,b){
        if (a.indexOf(b) < 0 ) a.push(b);
        return a;
    },[]);
    for(var i=0;i<uniqueButtonTypes.length;i++){
        window.addEventListener(uniqueButtonTypes[i]+"ButtonEvent",this.buttonEvent)
    }
    this.$refs.mobileButtonContainer.addEventListener("touchstart",this.touchStart)
  },
  methods:{
      touchStart(e){
          window.addEventListener('touchend',this.touchend)
          window.addEventListener('touchmove',this.touchmove)
          this.lastTouch.initialPosx=e.touches[0].clientX
          this.lastTouch.lastPosx=e.touches[0].clientX
      },
      touchmove(e){
          if(e.touches.length>=1){
            e.target.style="transform:translateX("+(e.touches[0].clientX-this.lastTouch.initialPosx)+"px)"
            this.lastTouch.lastPosx = e.touches[0].clientX
            e.stopPropagation()
            return false
          }
      },
      touchend(e){
          window.removeEventListener('touchmove',this.touchmove)
          window.removeEventListener('touchend',this.touchend)
          if(e){
            let move=this.lastTouch.lastPosx-this.lastTouch.initialPosx
            if(Math.abs(move)>100){
                if(move<0)
                    e.target.style="transform:translateX(-"+window.innerWidth+"px);transition: .25s ease;"
                else
                    e.target.style="transform:translateX("+window.innerWidth+"px);transition: .25s ease;"
                this.startDelete(e.target.getAttribute('id'))
            }
            else{
                e.target.style="transform:translateX(0px);transition: .25s ease;"
            }
            e.stopPropagation()
          }
          this.isSliding=false
          return false
      },
      itemClicked(item){
        let customEvent = new CustomEvent(item.buttonType + 'ButtonEvent',{
            detail: { 
                state:"clicked",
                data: item
            }
        });
        window.dispatchEvent(customEvent)

        if(item.link!=null){
            let customEvent = new CustomEvent('openLink',{
                detail: { 
                    routeLink: item.link,
                    alertText: item.alertText?item.alertText:null
                }
            });
            window.dispatchEvent(customEvent)
        }
      },
      buttonEvent(e){
          let curItemIndex = this.availableButtons.findIndex(x=>x.type==e.detail.data.type && x.name==e.detail.data.name)
          if(e.detail.state=="visible"){
              if(curItemIndex==-1){
                  this.availableButtons.push({...e.detail.data, curState: 'active'})
              }
          }
          else if(e.detail.state=="hidden"){
              if(curItemIndex!=-1){
                  this.availableButtons[curItemIndex].curState='inactive'
                  setTimeout(this.delteButton.bind(this,e.detail), 300);
              }
          }
          else if(e.detail.state=="clicked"){
            if (this.initialPrefs.sendEventsToDataLayer && parent && e.detail.data.isThisForMeButton) {
                this.$gtag.event('videoEvent',{
                'videoCategory': 'Springer Healthcare Interactive Video',
                'videoAction': "Video Interaction: click on the CTA Is this for me?'",
                'videoId': this.initialPrefs.videoID,
                'videoName': this.initialPrefs.projectName,
                'videoLive': 'false',
                });
            }
          }
      },
      delteButton(button){
          let curItemIndex = this.availableButtons.findIndex(x=>x.type==button.data.type && x.name==button.data.name);
          if(curItemIndex!=-1){
            this.$delete(this.availableButtons, curItemIndex)
          }
          this.touchend()
      },
      startDelete(id){
          let curItemIndex = this.availableButtons.findIndex(x=>x.buttonType+x.name=== id);
          if(curItemIndex!=-1){
            let customEvent = new CustomEvent(this.availableButtons[curItemIndex].buttonType + 'ButtonEvent',{
            detail: { 
                state:"hidden",
                data: this.availableButtons[curItemIndex]
            }
            });
            window.dispatchEvent(customEvent)
          }

      }
  }
}
</script>
